export default __webpack_public_path__ + "i18n/translation.3ad64bd6.json";